// import firebase from '@firebase/app'

import * as firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/database'

import { firebaseSettingsObject } from '@/constants'

/**
 *
 * GLOBAL VARS
 *
 */

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseSettingsObject)
}

let testFbAuth, testFbId, testFbStorage

if (!testFbAuth) testFbAuth = firebase.auth()
if (!testFbId) testFbId = firebase.database()
if (!testFbStorage) testFbStorage = firebase.storage()

const apiServerTimestamp = () => firebase.database.ServerValue.TIMESTAMP

const apiLogout = () => testFbAuth.signOut()

export {
  testFbAuth,
  testFbId,
  testFbStorage,
  apiServerTimestamp,
  apiLogout,
}
